import React from "react";

function LogoutIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <g
        id="Group_27758"
        data-name="Group 27758"
        transform="translate(20195 23823)"
      >
        <rect
          id="Rectangle_12671"
          data-name="Rectangle 12671"
          width="32"
          height="32"
          transform="translate(-20195 -23823)"
          fill="#9d2d20"
          opacity="0"
        />
        <path
          id="Path_18536"
          data-name="Path 18536"
          d="M4.6,21.2H7v2.4H21.4V4.4H7V6.8H4.6V3.2A1.2,1.2,0,0,1,5.8,2H22.6a1.2,1.2,0,0,1,1.2,1.2V24.8A1.2,1.2,0,0,1,22.6,26H5.8a1.2,1.2,0,0,1-1.2-1.2ZM7,12.8h8.4v2.4H7v3.6L1,14,7,9.2Z"
          transform="translate(-20191 -23821)"
        />
      </g>
    </svg>
  );
}

export default LogoutIcon;
